import { useSelector } from 'react-redux';
import { selectToken, selectUserEmail } from 'store/auth/selectors';
import { ROLE_GROUPS } from 'utils/constants';
import { isAuthorizedToAccessResource } from 'utils/helpers';

const ZOHO_CRITERIA_STRING = '?ZOHO_CRITERIA=%22Sr%20Ag%20Email%22=';
const ZOHO_ANALYTICS_URL = process.env.REACT_APP_ZOHO_ANALYTICS_URL || '';

const useCollectionOverviewLink = () => {
  const userEmail = useSelector(selectUserEmail);
  const userToken = useSelector(selectToken);

  const isAdminOrPM = isAuthorizedToAccessResource(
    userToken,
    ROLE_GROUPS.ADMIN_AND_PM,
  );

  const urlEncodedEmail = isAdminOrPM
    ? null
    : encodeURIComponent(`'${userEmail}'`);

  return isAdminOrPM
    ? ZOHO_ANALYTICS_URL
    : ZOHO_ANALYTICS_URL + ZOHO_CRITERIA_STRING + (urlEncodedEmail ?? '');
};

export default useCollectionOverviewLink;
